import type { TaskOutputWithNewlyCreated } from "@orsane/schema/tasks";

export interface ITableRow {
    key: string;
    isGroup(): boolean;
}

export class RowGroup {
    key: string;
    rows: Row[];
    groupedValue: string | number;
    firstRow: Row; // used to display group header stuff. groups are always based on some property of a row.

    isGroup(): boolean {
        return true;
    }

    constructor(key: string, rows: Row[], groupedValue: string | number) {
        this.key = key;
        this.rows = rows;
        this.groupedValue = groupedValue;
        this.firstRow = rows[0];
    }
}

export class Row {
    key: string;
    public data: TaskOutputWithNewlyCreated;
    group: RowGroup | undefined;
    depth: number;
    subtaskRows: Row[];
    hasSubtasks: boolean;
    isFilterMatch: boolean;

    isGroup(): boolean {
        return false;
    }

    constructor(key: string, data: TaskOutputWithNewlyCreated, depth = 0) {
        this.data = data;
        this.key = key;
        this.group = undefined;
        this.depth = depth;
        this.subtaskRows = [];
        this.hasSubtasks = false;
        this.isFilterMatch = data.isFilterMatch ?? true;
    }
}
